/* eslint-disable no-useless-computed-key */
let initialState = {
  selectLogicalBrandValue: {
    global_dashboard: { data: null },
    dashboard_section: { data: null },
    dashboard_widget: { data: null },
    template_global: { data: null },
    template_section: { data: null },
    template_widget: { data: null },
    graph_page: { data: null },
    orm_dashboard: { data: null },
    share_modal: { data: null },
    // added for shared dashboard multi-brand selection
    share_dashboard_global: { data: null },
    widgetMaker: { data: null },
    advance_settings: { data: null },
    preview: { data: null },
    CommandCenter: { data: null },
    CommandCenterCampaign: { data: null },
  },
  logicalBrandCheckedItems: {
    global_dashboard: { data: { ["All"]: true } },
    dashboard_section: { data: { ["All"]: true } },
    dashboard_widget: { data: { ["All"]: true } },
    template_global: { data: { ["All"]: true } },
    template_section: { data: { ["All"]: true } },
    template_widget: { data: { ["All"]: true } },
    graph_page: { data: { ["All"]: true } },
    orm_dashboard: { data: { ["All"]: true } },
    share_modal: { data: { ["All"]: true } },
    // added for shared dashboard multi-brand selection
    share_dashboard_global: { data: { ["All"]: true } },
    widgetMaker: { data: { ["All"]: true } },
    advance_settings: { data: { ["All"]: true } },
    preview: { data: { ["All"]: true } },
    CommandCenter: { data: { ["All"]: true } },
    CommandCenterCampaign: { data: { ["All"]: true } },
  },
  previewBrands: null,
};
const Logicalgroup = (state = initialState, action) => {
  switch (action.type) {
    case "SET_LOGICAL_BRAND_VALUE":
      return {
        ...state,
        selectLogicalBrandValue: action.payload,
      };
    case "SET_LOGICAL_BRAND_CHECKED_ITEMS":
      return {
        ...state,
        logicalBrandCheckedItems: action.payload,
      };
    case "SET_PREVIEW_BRANDS":
      return {
        ...state,
        previewBrands: action.payload,
      };

    default:
      return state;
  }
};

export default Logicalgroup;
